import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// 🟢 Use cleanAxios for EVERYTHING to completely bypass the 15s timeout
const cleanAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true, 
});

export const connectivityAPI = {
  initiateSession: async (data: { expertCode: string, sessionType: string, categoryId: number | null, intakeData?: any }) => {
    const response = await cleanAxios.post('/api/session/initiate', data);
    return response.data;
  },
  
  precheck: async (data: {
  expertCode: string;
  sessionType: 'chat' | 'call' | 'video';
  categoryId?: number | null;
}) => {
  const response = await cleanAxios.post('/api/intake/precheck', data);
  return response.data;
},

  leaveQueue: async (expertCode: string) => {
    const response = await cleanAxios.post('/api/session/leave-queue', { expertCode });
    return response.data;
  },

  // 🚀 NEW: Fetch live queue data for the Expert Dashboard
  getExpertQueueData: async (expertCode: string) => {
   
    const response = await cleanAxios.get(`/api/session/expert/queue/${expertCode}`);
    return response.data;
  },

  getChatHistory: async (sessionId: string) => {
    const response = await cleanAxios.get(`/api/view-chat-history/messages/${sessionId}`);
    return response.data;
  },

  getSessionHistoryInbox: async (role: string, code: string) => {
    const response = await cleanAxios.get(`/api/view-chat-history/inbox/${role}/${code}`);
    return response.data;
  },

  getSessionContext: async (sessionId: string) => {
    const response = await cleanAxios.get(`/api/session/context/${sessionId}`);
    return response.data;
  },

  uploadFile: async (file: File, sessionId: string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', sessionId);

    const response = await cleanAxios.post('/api/session/upload', formData, { 
      headers: { 'Content-Type': 'multipart/form-data' } 
    });
    
    return response.data; 
  }
};